import React from 'react';
import { DatoCmsInformationSectionVideo } from '../../../schema/datocms/blocks';
import { MediaContentGrid } from '../../../utilities/media-content-grid';
import HtmlStringComponent from '../../html-string/html-string-component';

const InformationSectionVideoComponent = ({ video, videoSize, videoAlignment, mainTextHtml, componentId }: DatoCmsInformationSectionVideo): React.ReactElement => {
    const mediaContentGrid: MediaContentGrid = new MediaContentGrid(videoSize, videoAlignment);

    let videoContent: JSX.Element | undefined = undefined;
    if (video) {
        // youtube videos need to use the embed URL to work in an iframe
        const videoUrl: string = video.provider === 'youtube' ? `https://www.youtube.com/embed/${video.providerUid}` : video.url;
        videoContent = (
            <div className={`flex justify-center lg:col-span-${mediaContentGrid.mediaColumns} lg:col-start-${mediaContentGrid.mediaStartColumn} aspect-w-16 aspect-h-9`}>
                <iframe className="w-full h-full" src={videoUrl} title={video.title} />
            </div>
        );
    }

    const descriptionGridClasses: string = `lg:col-end-${mediaContentGrid.contentEndColumn} lg:col-span-${mediaContentGrid.contentColumns} lg:row-start-${mediaContentGrid.contentStartRow}`;
    const videoItem = (
        <div id={componentId} className={`grid grid-cols-1 lg:grid-cols-${mediaContentGrid.gridColumns} lg:gap-4 lg:grid-rows-${mediaContentGrid.gridRows}`}>
            {videoContent}

            <HtmlStringComponent className={descriptionGridClasses} htmlString={mainTextHtml} />
        </div>
    );

    return videoItem;
};

export default InformationSectionVideoComponent;
